export {default as path} from "./src/path";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-path/index.js
// module id = 15
// module chunks = 0